import { bulkMarkAlertsRead, bulkMarkAlertsUnread } from '@/shared/api/bulk';

/**
 * Actions de masse des alertes, au format `shared/components/BulkEditDialog`.
 *
 * Les deux seules actions réversibles de l'admin : elles gardent un avertissement
 * honnête plutôt que le texte générique « ne peut pas être annulée », qui serait faux.
 */
const ALERT_BULK_ACTIONS = {
  read: {
    label: 'Marquer comme lues',
    family: 'action',
    warning: "Acquittement de lecture uniquement : l'alerte reste consultable et cette "
      + 'action se défait avec « Marquer comme non lues ».',
    run: ids => bulkMarkAlertsRead(ids),
  },
  unread: {
    label: 'Marquer comme non lues',
    family: 'action',
    warning: "Les alertes repassent en non lues et réapparaissent dans les compteurs.",
    run: ids => bulkMarkAlertsUnread(ids),
  },
};

export default ALERT_BULK_ACTIONS;
